import { formatMoney, SinglePaymentCriteria } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

export const principalFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.26,
    field: 'principal',
    headerName: <Text tId={'PRINCIPAL'} />,
    align: 'right',
    type: 'number',
    renderCell: (rowData: { row: SinglePaymentCriteria }) => (
      <div style={{ minWidth: '100px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        {formatMoney(amountToValueMoneyMapper(rowData.row.principal))}
      </div>
    ),
  };
};
